module.exports = __webpack_public_path__ + "static/media/ManageMultiUser3.41c9bf3c.png";